import ReactMarkdown from 'react-markdown';
import { useEffect, useState } from 'react';

export function MarkdownRenderer({ filePath }: { filePath: string }) {
  const [markdown, setMarkdown] = useState('');

  useEffect(() => {
    fetch(filePath)
      .then((response) => response.text())
      .then((text) => setMarkdown(text));
  }, [filePath]);

  return <ReactMarkdown>{markdown}</ReactMarkdown>;
}
